import { default as _91_46_46_46slug_93JeegPMQpPWMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/[...slug].vue?macro=true";
import { default as indexV6D4VRg6onMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/auth/index.vue?macro=true";
import { default as indexoGjEDb3IXtMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93knI5bxPIcHMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93TpPnQ5mxwpMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93JoTLA7IzVJMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93orE3wMHbhIMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/news/[slug].vue?macro=true";
import { default as organisationsqeY5JgBhyCMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsNMCntyam53Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programs9QESVHYdEnMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexyIKpaOkGcrMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/processes/index.vue?macro=true";
import { default as dungeoniyvV3ywHbRMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsG7JlnmtGzuMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexJEId5zTshgMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/secret/index.vue?macro=true";
import { default as indexxXYtU0FkYZMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDatafIOwI6xFaXMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClasswOFIPu5vy6Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93qmPaX1BV1rMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexkVnZeNEabVMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDatahENZj1hohHMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldsgPXeV03ZmHMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsyvtE85e2coMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsEZUhDV1ihqMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93jFHbesM3VAMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexpuFTYs2mLVMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesJMTnbTWgQXMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseData105VdiEqFDMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93PW1LcrhhB1Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexSPlgZwuwKvMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesN20VB2JWkZMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDatapgNMMGy2mZMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93ujsAmqgzwiMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as index8oolZ5bNT4Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseData23h5CKQW8MMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93U6uxz6NpDbMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexAGO7S7lCUWMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDatanJyuYFJrBNMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassWulZmJMJlvMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsoVeZoonIY1Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93rgqK7FUO61Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexkWvJlv8TTsMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiesrkjVnP0MGDMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDataGpAD4U73atMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsCTu8CXmrIJMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_935RuGwfIZhgMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexEmcfPfXj0pMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesuMwuHffL8JMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDatafrzFhb60lyMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsmAq5ixphkeMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93fywf6X9lh7Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as index3POAXSIf2gMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseData8q9I5zyN1OMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearData2ndQESmvKAMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93ZiGkQH2mWaMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexCRFq1LXBLfMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDataRT1MaBwh9HMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93wwuuzQBNkrMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexw3rVnIRvB2Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupsqzHRYSENXaMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDataI0v7tbVqaRMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93ncCxkR11d8Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexkHBIxPWnlnMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesdIoOKLQ0ZZMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesmw8Gf2VovyMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsHfsTCXTDSyMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataQLwUe9nPgQMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiasv4UAVTRborMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesylTdeIvg3jMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93BRIL5Bm2trMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexYviUEeD7CXMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionshKKJ2EWSKUMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltSPQopPxdRZMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDataWzL4yHoGRvMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsHLn4XauJFlMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93mjm8IV4XhwMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexxFo8Du1IoBMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsBylInTU4kDMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesmtU2DONu6XMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDatazoGFxhMINWMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93TietVsgzuVMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/processes/[id].vue?macro=true";
import { default as indexE7zchtHR08Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/processes/index.vue?macro=true";
import { default as _91id_93OJ2vcjOJ9mMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexsgxX2QBtxpMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersK7eoNG0H5cMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesyRPAnqGAeWMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettings7NgrLuE57UMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDataqUlJ0zCpUrMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategories6D2cMVYPk5Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConceptuUpAShbJprMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementaCQnAoktqjMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersiobxz32opIMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_931kURVL2SiXMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as index0dQLD4p5maMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsNCEps7yPy1Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivities0koG2k64ohMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseData31nWDZgE0YMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignature5VUvuurv6EMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93qDX5vFDloXMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexkIUnCWJIhuMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersaCVq9z4kFTMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/users.vue?macro=true";
import { default as settingstyTULO0XCQMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesWSuUZBQBF8Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDataKp2voSvaYMMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_930kXYZBOt77Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexYkMBaWsEANMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as service8MTkBSmLWoMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service.vue?macro=true";
import { default as languageWU7d1F93EaMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataO5LretRdkyMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesjuLdg0y8hxMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementlbqeckidnfMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersyTu5egvkEUMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93h1vws6fj7vMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDataEEBqtw2J5yMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureqytCykpuLgMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93nuiXxSGvg4Meta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/users/[id].vue?macro=true";
import { default as indexSqkHpbpUGRMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/users/index.vue?macro=true";
import { default as settingsDFeo20I0bcMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings.vue?macro=true";
import { default as signaturedjJ0nArLDVMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/signature.vue?macro=true";
import { default as sportbizzquN4SZQp8dMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93DvJrpku5NIMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93mHNCdB1kDzMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexWjKYObwqxcMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93vB3W35JJ8TMeta } from "/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93JeegPMQpPWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexV6D4VRg6onMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexoGjEDb3IXtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93knI5bxPIcHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93TpPnQ5mxwpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93JoTLA7IzVJMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsqeY5JgBhyCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexyIKpaOkGcrMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: service8MTkBSmLWoMeta?.name,
    path: "/service",
    meta: service8MTkBSmLWoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDataRT1MaBwh9HMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexxXYtU0FkYZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93qmPaX1BV1rMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexkVnZeNEabVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93jFHbesM3VAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexpuFTYs2mLVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93PW1LcrhhB1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexSPlgZwuwKvMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93ujsAmqgzwiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: index8oolZ5bNT4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93U6uxz6NpDbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexAGO7S7lCUWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93rgqK7FUO61Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexkWvJlv8TTsMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_935RuGwfIZhgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexEmcfPfXj0pMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93fywf6X9lh7Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsmAq5ixphkeMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: index3POAXSIf2gMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93ZiGkQH2mWaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexCRFq1LXBLfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93wwuuzQBNkrMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesdIoOKLQ0ZZMeta?.name,
    path: "parishes",
    meta: parishesdIoOKLQ0ZZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93ncCxkR11d8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionshKKJ2EWSKUMeta?.name,
    path: "regions",
    meta: regionshKKJ2EWSKUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93BRIL5Bm2trMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsBylInTU4kDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93mjm8IV4XhwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexxFo8Du1IoBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93TietVsgzuVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexE7zchtHR08Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/processes/index.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingstyTULO0XCQMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersK7eoNG0H5cMeta?.name,
    path: "loginProviders",
    meta: loginProvidersK7eoNG0H5cMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93OJ2vcjOJ9mMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexsgxX2QBtxpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsNCEps7yPy1Meta?.name,
    path: "organisations",
    meta: organisationsNCEps7yPy1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_931kURVL2SiXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: index0dQLD4p5maMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersaCVq9z4kFTMeta?.name,
    path: "users",
    meta: usersaCVq9z4kFTMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93qDX5vFDloXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexkIUnCWJIhuMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_930kXYZBOt77Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexYkMBaWsEANMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsDFeo20I0bcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93h1vws6fj7vMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93nuiXxSGvg4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexSqkHpbpUGRMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signaturedjJ0nArLDVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzquN4SZQp8dMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93DvJrpku5NIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93mHNCdB1kDzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexWjKYObwqxcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93vB3W35JJ8TMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250521122037/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]